import { LiveUpdate } from "@capawesome/capacitor-live-update";
import { RefreshCw } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
	OutlinedTextBlackButton,
	PrimaryButton,
} from "src/components/Default/LekUI/Button";
import {
	Modal,
	ModalFooter,
	ModalHeader,
} from "src/components/Modals/Components/ModalsComponents";

interface LiveUpdateReadyModalProps {
	onClose: () => void;
	onHidden: () => void;
}

const UpdateIcon = ({ className }: { className?: string }) => (
	<div className="icon-tile bg-soft-primary">
		<RefreshCw className={className} />
	</div>
);

export const LiveUpdateReadyModal = ({
	onClose,
	onHidden,
}: LiveUpdateReadyModalProps) => {
	const { t } = useTranslation();

	// Po zamknięciu modal może pokazać się znowu przy następnym wejściu do apki
	useEffect(() => onHidden, [onHidden]);

	return (
		<Modal onClose={onClose}>
			<div className="flex flex-col gap-24">
				<ModalHeader
					title={t("modals.liveUpdateReady.title", "Nowa wersja aplikacji")}
					description={t(
						"modals.liveUpdateReady.description",
						"Pojawiła się nowa aktualizacja aplikacji. Uruchom aplikację ponownie, żeby z niej skorzystać.",
					)}
					Icon={UpdateIcon}
				/>
				<ModalFooter vertical>
					<PrimaryButton
						className="w-100 btn-size-big border-radius-12"
						startIcon={<RefreshCw className="icon-normal" />}
						onClick={() => LiveUpdate.reload()}
						data-test-id="live-update-restart-button"
					>
						{t("modals.liveUpdateReady.restart", "Zaktualizuj teraz")}
					</PrimaryButton>
					<OutlinedTextBlackButton
						className="w-100 btn-size-big border-radius-12"
						onClick={onClose}
						data-test-id="live-update-later-button"
					>
						{t("modals.liveUpdateReady.later", "Zrobię to później")}
					</OutlinedTextBlackButton>
				</ModalFooter>
			</div>
		</Modal>
	);
};
